module.exports = __webpack_public_path__ + "img/title_cover.ecd90f7.png";